import React from "react";
import BgImg from "../assests/backgroundImage5.avif";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import banner3Img from "../assests/banner3.avif";
import banner4Img from "../assests/banner4.webp"
import { useMediaQuery, useTheme } from "@mui/material";

const BannerTwo = () => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(450));


    const styles = {
        container: {
            backgroundImage: `url(${BgImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            // minHeight: '100vh',
            color: 'white',
            textAlign: 'center',
            boxSizing: 'border-box',
            overflow: 'hidden',
            paddingTop: isSmall ? 50 : isMobile ? 30 : isBig ? 40 : '',
            paddingBottom: isSmall ? 50 : isMobile ? 30 : isBig ? 40 : 40
        },
        innerBox: {
            width: isMobile ? '95%' : '70%',
            borderRadius: '15px',
            border: '2px dashed #464d60',
            boxSizing: 'border-box',
            marginTop: 50,
            margin: 'auto',
            backgroundColor: '#16181c',
        },
        blackBox: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
        },
        leftBox: {
            width: isMobile ? '100%' : '35%',
            textAlign: 'left',
            padding: '20px',
            boxSizing: 'border-box',
            borderRadius: '15px'
        },
        rightBox: {
            width: isMobile ? '100%' : '65%',
            padding: '20px',
            boxSizing: 'border-box',
            borderRadius: '15px',
            textAlign: 'left',
            lineHegiht: 1.5
        }
    };

    return (
        <div style={styles.container}>
            <motion.div
                initial={{ opacity: 0, y: 50, scale: 0.6 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                viewport={{ amount: 0.5 }}
                style={{ fontSize: isMobile ? '20px' : '40px', fontWeight: 700, color: '#fff', margin: '50px auto' }}
            >
                Still Unsure? Checkout Some More Case Studies
            </motion.div>

            <div style={styles.innerBox}>
                <Swiper
                    modules={[Pagination, A11y, Autoplay]}
                    spaceBetween={50}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                >
                    <SwiperSlide>
                        <div style={styles.blackBox}>
                            <div style={styles.leftBox}>
                                <img src={banner4Img} style={{ width: '100%' }} alt="Case Study 2" />
                            </div>
                            <div style={styles.rightBox}>
                                <h4>LUXURY WOMEN'S FASHION BRAND</h4>
                                <h2>From $20k/month to $48k/month with 5.1X ROAS</h2>
                                <div style={{ lineHeight: 2 }}>
                                    During 2023, we played a pivotal role in elevating the visibility of a women's fashion brand. Our efforts on Facebook and Instagram resulted in a remarkable revenue generation of 5.18Cr, boasting an impressive average return on ad spend (ROAS) of 5.7x.
                                </div>
                                <div style={{ marginTop: 20, lineHeight: 2 }}>
                                    Our client's dynamic strategy encompassed frequent product launches, promotions, and sales on  a weekly basis. Throughout the year, we executed a staggering total of 3,456 ads, underlining our commitment to an aggressive scaling advertising approach.
                                </div>
                                <div style={{ marginTop: 20, lineHeight: 2 }}>
                                    This proactive advertising strategy not only fueled 183% of revenue growth but also facilitated the  brand's expansion into various international markets like Australia & UAE.
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div style={styles.blackBox}>
                            <div style={styles.leftBox}>
                                <img src={banner4Img} style={{ width: '100%' }} alt="Case Study 2" />
                            </div>
                            <div style={styles.rightBox}>
                                <h4>LIFESTYLE BRAND</h4>
                                <h2>From ₹5.7L/Month to ₹87L/Month</h2>
                                <div style={{ marginTop: 20, lineHeight: 2 }}>
                                    In a mere three months, we helped a lifestyle brand’s revenue from $20k to an impressive $48k per month. This exceptional growth was not driven by flashy creatives but by meticulous optimization of their media buying architecture, exhaustive A/B testing, and laser-focused audience targeting.
                                </div>
                                <div style={{ marginTop: 20, lineHeight: 2 }}>
                                    By leveraging DPA at its peak and implementing sophisticated cost cap strategies, we achieved remarkable efficiency and impact. This methodical approach significantly amplified their reach and engagement, culminating in a dramatic revenue increase and establishing a robust foundation for sustained growth.
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    );
};



export default BannerTwo;
